import React from 'react';
import { graphql } from 'gatsby';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';

import useStoryblok from '~/utils/storyblok-service';
import Image from '~/components/Dynamic/Image';
import DynamicComponent from '~/components/DynamicComponent';
import TextCard from '~/components/Dynamic/TextCard';

export default function Integrations({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;
  const hero = content?.hero[0];
  const components = story?.content?.body?.map((blok) => <DynamicComponent blok={blok} key={blok._uid} />);

  return (
    <Layout headerColor="white" className="" locale={pageContext.locale}>
      <Seo {...content.seo} lang={story.lang} pageContext={pageContext} />
      {hero && (
        <section className="pt-8 -mt-20 md:pt-20">
          <div className="container">
            <div className="flex flex-col items-center py-20 -ml-12 md:pt-36 md:pb-28 xl:pt-40 xl:pb-36 md:flex-row">
              <div className="flex w-full pl-12 mt-6 md:w-7/12 xl:w-6/12 md:mt-0">
                <TextCard blok={hero.textCard[0]} />
              </div>
              <div className="flex flex-col items-center w-full pl-12 mt-16 md:mt-0 md:w-5/12 xl:w-6/12">
                <Image blok={hero.asset[0]} />
              </div>
            </div>
          </div>
        </section>
      )}

      {components}
    </Layout>
  );
}

export const query = graphql`
  query integrationsQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
